/**
 * Broker Intelligence Hub — canonical navy+gold palette
 * Matches /pages/admin/ContactsPage, /pages/admin/SubscribersPage, /pages/agent-portal/AgentClientHub.
 * Single source of truth. Do not inline these constants elsewhere in this module.
 */

export const colors = {
  // Navy — backgrounds
  navy:  '#0F1E35',   // base page bg
  navy2: '#162844',   // elevated (stats strip, left panel, inline forms)
  navy3: '#1E3557',   // highest (inputs, hover, nav)

  // Gold — brand accent
  gold:  '#C9952A',
  gold2: '#E8B44A',
  gold3: '#F5D080',

  // Neutrals
  white: '#FFFFFF',
  off:   '#E8EEF6',
  offBg: '#eef1f6',   // right detail panel bg
  card:  '#f8f9fa',   // profile header card bg
  muted: '#8FA3BF',
  border: '#e9ecef',  // light gray card borders

  // Semantic
  green:  '#27ae60',
  red:    '#e74c3c',
  orange: '#f39c12',
  blue:   '#3498db',
} as const;

export const fonts = {
  display: "'Bebas Neue', sans-serif",
  body: "'DM Sans', -apple-system, sans-serif",
} as const;

export const FONT_LINK_HREF =
  'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600;700&display=swap';

// Common gradients used for primary actions and icon circles
export const gradients = {
  goldButton: `linear-gradient(135deg, ${colors.gold} 0%, ${colors.gold2} 100%)`,
  goldIcon: `linear-gradient(135deg, ${colors.gold} 0%, ${colors.gold3} 100%)`,
} as const;
